"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var strings_1 = require("../../../helpers/strings");
var Icon_1 = __importDefault(require("../../Icon"));
var PostViewContentTypes_1 = require("../../../constants/PostViewContentTypes");
var react_i18next_1 = require("react-i18next");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PostMainInfo = function (_a) {
    var postData = _a.postData;
    var t = react_i18next_1.useTranslation('common').t;
    var apartments = postData.sections.apartment_info || [];
    var onSaleAmount = react_1.useMemo(function () {
        return apartments.filter(function (apt) { return apt.availability === PostViewContentTypes_1.POST_AVAILABILITY.SALE; }).length;
    }, [apartments]);
    return (react_1.default.createElement("ul", { className: "post-main-info" },
        !postData.isDeveloper && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("li", null,
                react_1.default.createElement("i", { className: "icon-bedrooms" }),
                t('POST_PREVIEW.ROOMS'),
                react_1.default.createElement("span", { className: "count" }, postData.rooms_count &&
                    postData.rooms_count === '-1'
                    ? t('POST_CARD.FREE_LAYOUT_DESIGN')
                    : strings_1.valueOrDash(postData.rooms_count))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("i", { className: "icon-square-m" }),
                t('POST_PREVIEW.SQM'),
                react_1.default.createElement("span", { className: "count" }, strings_1.valueOrDash(postData.base_area))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("i", { className: "icon-floors" }),
                t('POST_PREVIEW.FLOOR'),
                react_1.default.createElement("span", { className: "count" },
                    postData.property_type !==
                        GeneralSettings_1.PROPERTY_TYPES.HOUSE && (react_1.default.createElement(react_1.default.Fragment, null,
                        strings_1.valueOrDash(postData.floor),
                        "/")),
                    strings_1.valueOrDash(postData.building_floors))))),
        postData.isDeveloper && (react_1.default.createElement("ul", { className: styles_module_scss_1.default.post_main_info },
            react_1.default.createElement("li", null,
                react_1.default.createElement(Icon_1.default, { name: "icon-ic-all-apts", className: styles_module_scss_1.default.icon }),
                postData.propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                    ? t('POST_PREVIEW.BUILDING_HOUSES_AMOUNT')
                    : postData.propertyType ===
                        PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                        ? t('POST_PREVIEW.BUILDING_APT_AMOUNT')
                        : postData.propertyType ===
                            PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                            ? t('POST_PREVIEW.BUILDING_COMMERCIALS_AMOUNT')
                            : t('POST_PREVIEW.BUILDING_APT_AMOUNT'),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.count }, strings_1.valueOrDash(postData.sections.about_building
                    .apartment_quantity))),
            react_1.default.createElement("li", null,
                react_1.default.createElement(Icon_1.default, { name: "icon-ic-free-apts", className: styles_module_scss_1.default.icon }),
                postData.propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                    ? t('POST_PREVIEW.BUILDING_VACANT_HOUSES_AMOUNT')
                    : postData.propertyType ===
                        PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                        ? t('POST_PREVIEW.BUILDING_VACANT_APT_AMOUNT')
                        : postData.propertyType ===
                            PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                            ? t('POST_PREVIEW.BUILDING_VACANT_COMMERCIALS_AMOUNT')
                            : t('POST_PREVIEW.BUILDING_VACANT_APT_AMOUNT'),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.count }, strings_1.valueOrDash(onSaleAmount)))))));
};
exports.default = PostMainInfo;
